import { useTranslation } from '@shared/localization';

import { ApiError } from '@/services/utils/ApiError';

import { ForbidenError } from './ForbidenError';
import { SomethingWentWrong } from '../general-errors/SomethingWentWrong';

interface IHttpErrorProps {
  readonly err: ApiError;
}

export function HttpError({ err }: IHttpErrorProps) {
  const { i18n } = useTranslation();

  if (err.status === 403 && i18n.isInitialized) {
    return <ForbidenError />;
  }

  return <SomethingWentWrong err={err} />;
}
